import { render } from "./DetaliiUtilizator.vue?vue&type=template&id=b3e97eaa&scoped=true"
import script from "./DetaliiUtilizator.vue?vue&type=script&lang=js"
export * from "./DetaliiUtilizator.vue?vue&type=script&lang=js"

import "./DetaliiUtilizator.vue?vue&type=style&index=0&id=b3e97eaa&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\peles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3e97eaa"]])

export default __exports__